<app-replace-file-dialog></app-replace-file-dialog>
<app-add-new-location-dialog [toast]="toast"></app-add-new-location-dialog>
<app-toast></app-toast>

<div class="flex flex-wrap gap-2">
    <div class="flex-[1] min-w-[300px] h-[350px] max-w-[1000px] min-h-[250px]">
        <!-- Upload button -->
        <app-location-file-upload [toast]="toast" [showListOfRecentUploadsAfterUpload]="false"></app-location-file-upload>
    </div>
    
    <div class="flex-[1] min-w-[300px] h-[350px] max-w-[1000px] rounded-[16px] border-spacing-2 border-2 border-border bg-white flex flex-col select-none min-h-[250px]">
        
        <div class="flex-1 flex flex-col justify-center items-center">
            <div class="w-[80px] h-[80px] flex items-center justify-center rounded-full text-white font-bold uppercase overflow-hidden bg-primary-300">
                <img src="assets/icons/magicpen.svg" width="60px" height="60px" alt="{{ 'shared.upload_icon' | transloco }}">
            </div>
        </div>

        <div class="flex-1 flex flex-col justify-center items-center px-4">
            <p class="text-center textarea-md text-neutral-500">
                {{ 'shared.fill_information_manually.fill_all_relevant_info' | transloco }}
                <b class="text-black">{{ 'shared.fill_information_manually.manually' | transloco }}</b>
            </p>
        </div>

        <div class="flex-1 flex flex-col justify-center items-center">
            <div class="max-w-screen-sm w-11/12">
                <app-primary-button buttonText="{{ 'shared.add_data' | transloco }}" [isDisabled]="false"
                    (buttonClick)="openAddLocationDataDialog()">
                </app-primary-button>
            </div>
        </div>
    </div>
</div>

<div
    class="min-w-[300px] h-[350px] rounded-[16px] border-spacing-2 border-2 border-border bg-white flex flex-col min-h-[250px] p-4 mt-5">
    <h1 class="font-bold text-xl mb-4">{{ 'auth.onboarding_step_4.uploaded_files' | transloco }}</h1>
    <div class="h-4/5 w-full overflow-y-auto">
        <ng-container *ngFor="let uploadInfo of listOfRecentUploads; let i = index">
            <app-uploaded-file [fileSrc]="uploadInfo.fileSrc" [fileName]="uploadInfo.fileName"
                [fileSize]="uploadInfo.fileSizeMB" [currentValue]="uploadInfo.currentUploadProgress"
                (stopClick)="stopClicked(i)" [canceled]="uploadInfo.canceled"></app-uploaded-file>
        </ng-container>
    </div>
</div>